import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Dropdown, Accordion } from "react-bootstrap";
import Utils from "../../services/Utils";
const AccordionOperations = ({
  operation,
  keyAccordion,
  handleShowUpdate,
  deleteOperation,
  getNameMonth,
}) => {
  return (
    <div>
      <Accordion className="mb-5 w-100 m-auto" alwaysOpen key={keyAccordion}>
        <Accordion.Item
          eventKey={keyAccordion}
          className="mb-4"
          style={{
            backgroundColor: Utils.getColorAlternative(
              operation.operation_type.color,
              20
            ),
          }}
        >
          <div className="row w100 align-items-center">
            <div
              className={
                parseInt(localStorage.getItem("user_role")) !== 5 &&
                parseInt(localStorage.getItem("user_role")) !== 6
                  ? "col-md-10"
                  : "col-md-12"
              }
            >
              <Accordion.Header as="div">
                <div className="row w100">
                  <div
                    className={
                      operation.month_2
                        ? operation.month_3
                          ? "col-md-6"
                          : "col-md-8"
                        : "col-md-10"
                    }
                  >
                    <span
                      style={{ backgroundColor: operation.brand.color }}
                      className="rounded white marque"
                    >
                      {operation.brand.name}
                    </span>
                    <span
                      className="accordion-title accordion-user-name me-3"
                      style={{ color: operation.operation_type.color }}
                    >
                      {operation.operation_type.name}
                    </span>
                  </div>
                  <div className="col-2 ">
                    <span className="accordion-title accordion-user-name me-3">
                      {getNameMonth(operation.month_1)}
                    </span>
                  </div>
                  {operation.month_2 && (
                    <div className="col-2 ">
                      <span className="accordion-title accordion-user-name me-3">
                        {getNameMonth(operation.month_2)}
                      </span>
                    </div>
                  )}
                  {operation.month_3 && (
                    <div className="col-2 ">
                      <span className="accordion-title accordion-user-name me-3">
                        {getNameMonth(operation.month_3)}
                      </span>
                    </div>
                  )}
                  <div className="col-md-12">
                    <LocalOfferOutlinedIcon
                      style={{ color: operation.operation_type.color }}
                    />
                    <span
                      className="accordion-title-offre accordion-user-name me-3"
                      style={{ color: operation.operation_type.color }}
                    >
                      &emsp; {operation.description}
                    </span>
                  </div>
                </div>
              </Accordion.Header>
            </div>
            {parseInt(localStorage.getItem("user_role")) !== 5 &&
              (parseInt(localStorage.getItem("user_role")) !== 6 && (
                <div className="col-md-2 text-end">
                  <Dropdown>
                    <Dropdown.Toggle>
                      <MoreVertIcon />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          handleShowUpdate(operation);
                        }}
                      >
                        <EditOutlinedIcon className="grey" /> Modifier
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          deleteOperation(operation.id);
                        }}
                      >
                        <DeleteOutlinedIcon className="red" /> Supprimer
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ))}
          </div>
          <div className="container-fluid">
            <Accordion.Body>
              <div className="row">
                <div className="col-md-6 have-border-top pt-4">
                  <div className="data-label px-3">Offres</div>
                  <div className="grey  px-3">
                    <p>{operation.description}</p>
                  </div>
                  <div className="data-label px-3">Prestataire</div>
                  <div className="grey  px-3">
                    <p>{operation.provider && operation.provider.name}</p>
                  </div>
                </div>
                <div className="col-md-6 have-border-top have-border-left pt-4 pb-4">
                  <div className="data-label px-3">
                    <div className="data-label px-3">Merchandising </div>
                    {operation.operation_plv_value.length > 0 &&
                      operation.operation_plv_value.map((comTool, key) => (
                        <div className="row grey px-3" key={key}>
                          <div className="col-md-8">
                            {comTool.operation_plv.operation_plv_type.name}
                          </div>
                          <div className="col-md-4">{comTool.provider}</div>
                        </div>
                      ))}
                  </div>
                  <div className="grey  px-3">
                    {operation.operation_com_tool.length > 0 &&
                      operation.operation_com_tool.map((comTool, key) => (
                        <p key={key}>{comTool.operation_com_tool_type.name}</p>
                      ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 have-border-top pt-4">
                  <div className="data-label px-3">Commentaire</div>
                  <div className="grey  px-3">
                    <p>{operation.comment}</p>
                  </div>
                </div>
                <div className="col-md-6 have-border-top pt-4">
                  <div className="data-label px-3">Animations</div>
                  <div className="grey  px-3">
                    <p>{operation.animations ? operation.animations : 'aucune'}</p>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default AccordionOperations;
